<template>
  <div class="v-view chart-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}</div>
    <div class="ElderlyData-content" v-if="elder && elder.length > 0">
      <div class="E-number">
        <div>
          <p>人口总数</p>
          <p>{{ elder[0].Value || '0' }}</p>
        </div>
        <div class="pointer" @click="getElderDetil('全部')">
          <p>老人总数</p>
          <p>{{ elder[1].Value || '0' }}</p>
        </div>
        <div>
          <p>老人占比</p>
          <p>{{ elder[2].Value || '0' }}</p>
        </div>
      </div>
      <div class="E-sex">
        <div class="pointer" @click="getElderDetil('男性')">
          <p>男性</p>
          <p>{{ elder[3].Value || '0' }}</p>
        </div>
        <div class="pointer" @click="getElderDetil('女性')">
          <p>女性</p>
          <p>{{ elder[4].Value || '0' }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Mixins} from '../minix/index'
import PubSub from 'pubsub-js'
import { mapGetters } from 'vuex'

export default {
  name: 'ElderlyData',
  mixins:[Mixins],
  computed: {
    ...mapGetters(['cid']),
  },
  props: {
    type: {
      type: String,
      default: 'pie',
    },
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '老人数据统计',
    },
  },
  watch: {},
  data() {
    return {
      visible: false,
    }
  },
  created() {
    this.getElderAgeData(this.cid)
  },
  beforeDestroy() { },
  methods: {
    getElderDetil(params) {
      this.keyWord = params
      PubSub.publish('ElderDetail', {
        keyWord: params,
        visible: true
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.ElderlyData-content {
  width: 100%;
  height: 100%;
  // background-color: red;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.E-number {
  width: 100%;
  height: 14.62vh;
  // background-color: pink;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 10px;

  div {
    width: 148px;
    height: 100%;
    background: url(../assets/images/yongning/elderTotal.png) no-repeat center/auto 100%;

    p:first-child {
      padding-top: 8.5vh;
      margin-bottom: .5vh;
    }

    p {
      text-align: center;
    }

    p:last-child {
      background: -webkit-linear-gradient(#ffcb32, #ffe6bd);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: "pmzd";
      font-size: 26px;
    }
  }

  div:first-child {
    background: url(../assets/images/yongning/populationTotal.png) no-repeat center/auto 100%;

    p:last-child {
      background: -webkit-linear-gradient(#00fcff, #bdf8ff);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: "pmzd";
      font-size: 26px;
    }
  }

  div:last-child {
    background: url(../assets/images/yongning/percentage.png) no-repeat center/auto 100%;

    p:last-child {
      background: -webkit-linear-gradient(#00ff9c, #c7ffe9);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: "pmzd";
    }
  }
}

.E-sex {
  width: 100%;
  height: 7.41vh;
  // background-color: pink;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 10px;

  div {
    width: 227px;
    height: 100%;
    padding: 10px 14px;
    padding-left: 60px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    background: url(../assets/images/yongning/nam.png) no-repeat center/ auto 100%;

    p {
      width: 100%;

      text-align: center;
    }

    p:last-child {
      background: -webkit-linear-gradient(#19d1f2, #069bfd);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: "pmzd";
      font-size: 26px;
    }
  }

  div:last-child {
    background: url(../assets/images/yongning/woman.png) no-repeat center/ auto 100%;

    p:last-child {
      background: -webkit-linear-gradient(#ed89b3, #d35d8f);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: "pmzd";
      font-size: 26px;
    }
  }
}
</style>
